// 需登录才能访问的路由:无 token 时跳登录
import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuthStore } from '@/store/auth';
import { ROUTES } from '@/routes';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthed = useAuthStore((s) => !!s.accessToken && !!s.user);
  const location = useLocation();
  if (!isAuthed) {
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
